import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-week-day-selector',
    templateUrl: './week-day-selector.component.html',
    styleUrls: ['./week-day-selector.component.css'],
    standalone: false
})
export class WeekDaySelectorComponent implements OnInit {

  @Input()
  public mask: number;

  @Output()
  public maskChange: EventEmitter<number> = new EventEmitter;

  constructor() { }

  ngOnInit() {
  }

  public isDayChecked(day: number): boolean {
    return (this.mask & day) == day;
  }

  
  public onCalculateMask(value, isOn: boolean) {
    if (isOn)
      this.mask = this.mask | value;
    else
      this.mask = this.mask ^ value;
    this.maskChange.emit(this.mask);
  }

  onCheckboxChange(id: number, event: Event) {
    const input = event.target as HTMLInputElement;
    this.onCalculateMask(id, input.checked);
  }

}
